var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { NextImg } from '@bfa/common-ui';
import React from 'react';
import { AnalyticsLink } from '../../../../../../../components/Analytics';
import { REFRESHMENTS_URLS } from '../../../../../../../constants';
import { SUBSCRIBED_LANDING_NEXT_SHIPMENT_SUMMARY_SECTION_EVENTS as EVENTS } from '../../../../../../../utils/analytics/events';
import { SummaryItemBox, SummaryItemName, } from '../../DetailedNextShipmentSummary.styled';
var SummaryItem = function (_a) {
    var item = _a.item;
    return (React.createElement(AnalyticsLink, { key: item.id, href: "".concat(REFRESHMENTS_URLS.PDP, "/").concat(item.productId), eventData: __assign(__assign({}, EVENTS.CLICK_ON_NEXT_SHIPMENT_PRODUCT_CARD), { properties: { productId: item.productId } }), passHref: true },
        React.createElement(SummaryItemBox, { "data-testid": "summary-item-".concat(item.type, "-").concat(item.productId) },
            React.createElement(NextImg, { images: [
                    {
                        src: item.src,
                        alt: item.alt,
                        width: 4,
                        height: 3,
                    },
                ], layout: "fill" }),
            React.createElement(SummaryItemName, null, item.name))));
};
export default SummaryItem;
